var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclusiveDiscounts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0015 45V28V26.5L11.0015 25.5H12.0015H13.5015L15.5015 26.5L17.5015 27L19.0015 26.5L21.0015 25.5L22.0015 25H23.0015L23.5015 25.5V30V39.5V46V48.5L23.0015 50.5L21.0015 53L19.0015 54H14.5015L11.5015 52L10.0015 48.5V45Z",
    fill: "#26B8E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5395 14.0698V25.5561V47.5195C23.5395 51.3568 20.4311 54.4651 16.5938 54.4651H48.9613C54.5189 54.4651 57.6013 50.7211 57.6013 44.6731L57.6248 14.0698C57.6248 11.8567 55.5075 10.4193 53.6704 11.3611L51.9296 12.2796C50.8917 12.8218 49.6931 12.8452 48.6085 12.373L43.6891 10.1831C41.6888 9.31395 39.4755 9.31395 37.4749 10.1831L32.5557 12.373C31.4712 12.8452 30.2699 12.8218 29.2347 12.2796L27.4936 11.3611C25.6567 10.4193 23.5395 11.88 23.5395 14.0698Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5941 54.4642C14.6637 54.4642 12.9227 53.6885 11.6747 52.4405C10.4034 51.169 9.625 49.4255 9.625 47.5183V28.1914C9.625 25.9781 11.7448 24.5433 13.5817 25.4851L15.3227 26.4036C16.358 26.9458 17.5593 26.9693 18.6412 26.497L21.9623 25.0155C22.2192 24.8962 22.8808 25.2023 23.5398 25.5552",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.917 39.0453L47.2543 26.708",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9553 38.8537V38.9748M47.4462 38.8796C47.4462 39.1524 47.2249 39.3737 46.9521 39.3737C46.6796 39.3737 46.4585 39.1524 46.4585 38.8796C46.4585 38.6071 46.6796 38.3857 46.9521 38.3857C47.2249 38.3857 47.4462 38.6071 47.4462 38.8796Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9553 26.8537V26.9747M35.4462 26.8795C35.4462 27.1523 35.2249 27.3737 34.9521 27.3737C34.6796 27.3737 34.4585 27.1523 34.4585 26.8795C34.4585 26.6069 34.6796 26.3857 34.9521 26.3857C35.2249 26.3857 35.4462 26.6069 35.4462 26.8795Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveDiscounts);
export default __webpack_public_path__ + "static/media/ExclusiveDiscounts.07c436cbe31d7dc4f61f2d66eef4381f.svg";
export { ForwardRef as ReactComponent };